import React, { useCallback, useEffect, useState } from 'react';
import { Col, Layout, PageHeader, Row, Tabs } from 'antd';
import { useHistory, useParams } from 'react-router';
import { Grid } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';
import { GridDetailsForm } from './grid-details-form';
import { FieldsPage } from './fields-page';

export function GridPage() {
  const history = useHistory();
  const { id } = useParams() as any;
  const [grid, setGrid] = useState<Grid>();
  const [loading, setLoading] = useState(false);

  const { Content } = Layout;

  const onBackClick = () => {
    history.goBack();
  };

  const loadGrid = useCallback(() => {
    setLoading(true);
    apiClient
      .get(`grids/${id}`)
      .then((response: any) => {
        setGrid(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const onGridChanged = (grid: Grid) => {
    setGrid(grid);
  };

  useEffect(() => {
    if (!id) {
      return;
    }
    loadGrid();
  }, [id, loadGrid]);

  const TabContent = (props: any) => {
    return (
      <Content style={{ backgroundColor: '#fff' }}>
        <Row>
          {props.fullWidth ? (
            <Col span={24}>{props.children}</Col>
          ) : props.large ? (
            <Col span={16} xs={24} sm={24} md={24} lg={24} xl={24} xxl={16}>
              {props.children}
            </Col>
          ) : (
            <Col span={8} xs={24} sm={24} md={12} lg={10} xl={10} xxl={8}>
              {props.children}
            </Col>
          )}
        </Row>
      </Content>
    );
  };

  return (
    <>
      <PageHeader title="Veri seti düzenle" subTitle={grid?.name} onBack={onBackClick} />
      <Content>
        <Tabs>
          <Tabs.TabPane tab="Detaylar" key="details">
            <TabContent fullWidth={true}>
              <GridDetailsForm grid={grid} onSaved={onGridChanged} />
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Veri elemanları" key="fields">
            <TabContent fullWidth={true}>
              <FieldsPage grid={grid} gridLoading={loading} onSaved={onGridChanged} />
            </TabContent>
          </Tabs.TabPane>
        </Tabs>
      </Content>
    </>
  );
}
